import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Form, Table, Badge as BsBadge, Button, Tooltip, OverlayTrigger, Modal, Nav, Tab } from 'react-bootstrap';
import { useQuery, useQueryClient } from 'react-query';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { DUYET_HOSO_TUYENSINH_API, DOTTUYENSINH_API, LOPDAOTAOLIENTUC_API, LOPDAOTAOTHUCHANH_API } from '@app/utils/apiUrl';
import { ACCOUNT_API } from '../../../../../utils/apiUrl';
import { Get, Put } from '@app/utils/httpProvider';
import { toast } from 'react-toastify';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { 
    trangThaiHoSoDuTuyenValue,
    objectTrangThaiHoSoDuTuyen,
    objectShowNumber
} from '../../../../../utils/define';
import DuyetHoSoTuyenSinhDetailModal from './DuyetHoSoTuyenSinhDetailModal';
import ChamDiemDeCuongModalWrapper from '../../tuyenSinhTienSi/chiTietKetQuaNCS/ChamDiemDeCuongModalWrapper';
import DanhGiaHoSoTuyenSinhTienSiForm from '../../tuyenSinhTienSi/chiTietKetQuaNCS/DanhGiaHoSoTuyenSinhTienSiForm';
import KetQuaTuyenSinhTab from './KetQuaTuyenSinhTab';

const DuyetHoSoTuyenSinh = () => {
    const history = useHistory();
    const location = useLocation();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [searchSoHoSo, setSearchSoHoSo] = useState('');
    const [trangThaiFilter, setTrangThaiFilter] = useState('');
    const [namTuyenSinh, setNamTuyenSinh] = useState(new Date().getFullYear());
    const [dotTuyenSinhId, setDotTuyenSinhId] = useState('');
    const [activeTab, setActiveTab] = useState('0');
    const [selectedRow, setSelectedRow] = useState(null);
    const queryClient = useQueryClient();
    const tableRef = useRef(null);
    
    // Modal states
    const [showDetail, setShowDetail] = useState(false);
    const [selectedHoSoId, setSelectedHoSoId] = useState(null);

    const [showChamDiemModal, setShowChamDiemModal] = useState(false);
    const [selectedHoSoIdChamDiem, setSelectedHoSoIdChamDiem] = useState(null);

    const [showDanhGiaModal, setShowDanhGiaModal] = useState(false);
    const [selectedHoSoIdDanhGia, setSelectedHoSoIdDanhGia] = useState(null);

    const [showKetQuaModal, setShowKetQuaModal] = useState(false);
    const [selectedHoSoIdKetQua, setSelectedHoSoIdKetQua] = useState(null);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [actionType, setActionType] = useState(null);
    const [ghiChuChinhSua, setGhiChuChinhSua] = useState('');
    const [submitting, setSubmitting] = useState(false);

    // Khởi tạo state từ URL params chỉ 1 lần khi component mount
    useEffect(() => {
        const paramUrl = new URLSearchParams(location.search.substring(1));
        if (paramUrl.get('page') != null) {
            setPage(parseInt(paramUrl.get('page'), 10));
        }
        if (paramUrl.get('size') != null) {
            setPageSize(parseInt(paramUrl.get('size'), 10));
        }
        if (paramUrl.get('search') != null) {
            setSearch(paramUrl.get('search'));
        }
        if (paramUrl.get('sohoso') != null) {
            setSearchSoHoSo(paramUrl.get('sohoso'));
        }
        if (paramUrl.get('nam') != null) {
            setNamTuyenSinh(parseInt(paramUrl.get('nam'), 10));
        }
        if (paramUrl.get('dot') != null && paramUrl.get('dot') !== '') {
            setDotTuyenSinhId(paramUrl.get('dot'));
        }
    }, []);

    const replaceHistory = (Page, Size, Search, SearchSoHoSo, Nam, Dot) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DUYET_HOSOTUYENSINH_PATH, {
                page: Page,
                size: Size,
                search: Search,
                sohoso: SearchSoHoSo,
                nam: Nam,
                dot: Dot
            })
        );
    };

    const { data: listNamDataTS } = useQuery(
        ['listNamTuyenSinhDuyetHoSoTS'],
        () => Get(DOTTUYENSINH_API.GET_LIST_NAM, null, null),
        { keepPreviousData: true }
    );
    const { data: listNamDataLT } = useQuery(
        ['listNamTuyenSinhDuyetHoSoLT'],
        () => Get(LOPDAOTAOLIENTUC_API.GET_LIST_NAM_KHAI_GIANG, null, null),
        { keepPreviousData: true }
    );
    const { data: listNamDataTH } = useQuery(
        ['listNamTuyenSinhDuyetHoSoTH'],
        () => Get(LOPDAOTAOTHUCHANH_API.GET_LIST_NAM_KHAI_GIANG, null, null),
        { keepPreviousData: true }
    );

    let rawListNam = [];
    if (activeTab === '0') {
        rawListNam = (Array.isArray(listNamDataTS) ? listNamDataTS : listNamDataTS?.$values) || [];
    } else if (activeTab === '1') {
        rawListNam = (Array.isArray(listNamDataLT) ? listNamDataLT : listNamDataLT?.$values) || [];
    } else if (activeTab === '2') {
        rawListNam = (Array.isArray(listNamDataTH) ? listNamDataTH : listNamDataTH?.$values) || [];
    }
    const listNam = rawListNam.length > 0 ? Array.from(new Set(rawListNam)).sort((a, b) => a - b) : [new Date().getFullYear()];

    useEffect(() => {
        if (rawListNam.length > 0 && !rawListNam.includes(namTuyenSinh)) {
            const maxYear = Math.max(...rawListNam);
            setNamTuyenSinh(maxYear);
            replaceHistory(1, pageSize, search, maxYear, '');
        }
    }, [activeTab, listNamDataTS, listNamDataLT, listNamDataTH, namTuyenSinh]);

    const { data: listDotTuyenSinhDataTS } = useQuery(
        ['listDotTuyenSinhByNamTS', namTuyenSinh],
        () => Get(DOTTUYENSINH_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000, NamTuyenSinh: namTuyenSinh }),
        { enabled: !!namTuyenSinh && activeTab === '0', keepPreviousData: true }
    );
    const { data: listDotTuyenSinhDataLT } = useQuery(
        ['listDotTuyenSinhByNamLT', namTuyenSinh],
        () => Get(LOPDAOTAOLIENTUC_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000, NamKhaiGiang: namTuyenSinh }),
        { enabled: !!namTuyenSinh && activeTab === '1', keepPreviousData: true }
    );
    const { data: listDotTuyenSinhDataTH } = useQuery(
        ['listDotTuyenSinhByNamTH', namTuyenSinh],
        () => Get(LOPDAOTAOTHUCHANH_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000, NamKhaiGiang: namTuyenSinh }),
        { enabled: !!namTuyenSinh && activeTab === '2', keepPreviousData: true }
    );

    let listDotTuyenSinh = [];
    if (activeTab === '0') {
        listDotTuyenSinh = listDotTuyenSinhDataTS?.data?.$values || listDotTuyenSinhDataTS?.data || [];
    } else if (activeTab === '1') {
        listDotTuyenSinh = listDotTuyenSinhDataLT?.data?.$values || listDotTuyenSinhDataLT?.data || [];
    } else if (activeTab === '2') {
        listDotTuyenSinh = listDotTuyenSinhDataTH?.data?.$values || listDotTuyenSinhDataTH?.data || [];
    }

    // Automatically set default "Tất cả" dotTuyenSinhId when year changes or active tab changes
    useEffect(() => {
        setDotTuyenSinhId('');
    }, [namTuyenSinh, activeTab]);

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['duyetHoSoTuyenSinh', search, searchSoHoSo, page, pageSize, trangThaiFilter, namTuyenSinh, dotTuyenSinhId, activeTab],
        () => {
            const model = {
                Keyword: search || '',
                SoHoSo: searchSoHoSo || '',
                PageIndex: page,
                PageSize: pageSize,
                TrangThaiHoSoDuTuyens: trangThaiFilter ? [Number(trangThaiFilter)] : [1, 2, 3, 4], // Lọc các hồ sơ đã gửi đi
                NamTuyenSinh: namTuyenSinh,
                LoaiTuyenSinh: Number(activeTab)
            };
            if (dotTuyenSinhId) {
                model.DotTuyenSinhId = dotTuyenSinhId;
            }
            replaceHistory(page, pageSize, search, searchSoHoSo, namTuyenSinh, dotTuyenSinhId);
            return Get(DUYET_HOSO_TUYENSINH_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page, trangThaiFilter, namTuyenSinh, dotTuyenSinhId, activeTab, search, searchSoHoSo]);

    const handleSelectTab = (k) => {
        setActiveTab(k);
        setPage(1);
    };

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, searchSoHoSo, namTuyenSinh, dotTuyenSinhId);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search, searchSoHoSo, namTuyenSinh, dotTuyenSinhId);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    useEffect(() => {
        if (items && items.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = items.find(item => (item.id || item.Id) === (prev.id || prev.Id));
                    return fresh || items[0];
                }
                return items[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [data, activeTab]);

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    const handleViewDetail = (app) => {
        setSelectedHoSoId(app.id || app.Id);
        setShowDetail(true);
    };

    const handleOpenChamDiem = (app) => {
        setSelectedHoSoIdChamDiem(app.id || app.Id);
        setShowChamDiemModal(true);
    };

    const handleOpenConfirm = (app, actionId) => {
        setSelectedHoSoId(app.id || app.Id);
        setActionType(actionId);
        setGhiChuChinhSua('');
        setShowConfirmModal(true);
    };

    const handleDuyet = async () => {
        if (!ghiChuChinhSua && (actionType === 2 || actionType === 4)) {
            toast.warning('Vui lòng nhập ghi chú / lý do để gửi tới người dùng!');
            return;
        }

        setSubmitting(true);
        try {
            const result = await Put(DUYET_HOSO_TUYENSINH_API.DUYET_HO_SO, selectedHoSoId, {
                Action: actionType,
                GhiChuChinhSua: ghiChuChinhSua
            });

            if (result && result.ok) {
                toast.success('Duyệt hồ sơ thành công!');
                setShowConfirmModal(false);
                setSelectedHoSoId(null);
                queryClient.invalidateQueries(['duyetHoSoTuyenSinh']);
                queryClient.invalidateQueries(['myApplications']);
                refetch();
            } else {
                toast.error(result?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
            }
        } catch (e) {
            toast.error('Lỗi kết nối máy chủ!');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="container-fluid">
            <Tab.Container activeKey={activeTab} onSelect={handleSelectTab} id="tabs-duyet-ho-so-tuyen-sinh">
            <Card className="card-sticky-layout card-sticky-layout-lg">
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <Nav variant="pills" className="flex-row">
                            <Nav.Item>
                                <Nav.Link eventKey="0" className="font-weight-bold">Tuyển sinh Tiến sĩ</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="1" className="font-weight-bold">Tuyển sinh đào tạo liên tục</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="2" className="font-weight-bold">Tuyển sinh đào tạo thực hành</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                </Card.Header>
                <Card.Body className="d-flex flex-column p-0">
                    <Card className="card-sticky-layout border-0 shadow-none flex-grow-1">
                        <Card.Body className="d-flex flex-column">
                            <Tab.Content className="d-flex flex-column flex-grow-1">
                                <Tab.Pane eventKey={activeTab} className="d-flex flex-column flex-grow-1 h-100">
                    <div className="d-flex mb-3 flex-wrap">
                        <div className="d-flex align-items-center mr-3 mb-2">
                            <span className="font-weight-bold mr-2">Tìm kiếm:</span>
                            <Form.Control 
                                type="text" 
                                placeholder="Nhập tên hoặc CCCD..." 
                                value={search} 
                                onChange={(e) => { setSearch(e.target.value); setPage(1); }} 
                                style={{ width: '250px' }} 
                            />
                        </div>
                        <div className="d-flex align-items-center mr-3 mb-2">
                            <span className="font-weight-bold mr-2">Số hồ sơ:</span>
                            <Form.Control 
                                type="text" 
                                placeholder="Nhập số hồ sơ..." 
                                value={searchSoHoSo} 
                                onChange={(e) => { setSearchSoHoSo(e.target.value); setPage(1); }} 
                                style={{ width: '200px' }} 
                            />
                        </div>
                        <div className="d-flex align-items-center mr-3 mb-2">
                            <span className="font-weight-bold mr-2">{activeTab === '0' ? 'Đợt tuyển sinh:' : 'Lớp tuyển sinh:'}</span>
                            <Form.Control as="select" value={dotTuyenSinhId} onChange={(e) => { setDotTuyenSinhId(e.target.value); setPage(1); }} style={{ width: '250px' }}>
                                <option value="">{activeTab === '0' ? 'Tất cả đợt' : 'Tất cả lớp'}</option>
                                {listDotTuyenSinh.map((dot) => (
                                    <option key={dot.id || dot.Id} value={dot.id || dot.Id}>{dot.tenDot || dot.TenDot || dot.tenKhoaHoc || dot.TenKhoaHoc}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div className="d-flex align-items-center mr-3 mb-2">
                            <span className="font-weight-bold mr-2">Trạng thái:</span>
                            <Form.Control
                                as="select"
                                value={trangThaiFilter}
                                onChange={(e) => { setTrangThaiFilter(e.target.value); setPage(1); }}
                                style={{ width: '200px' }}
                            >
                                <option value="">Tất cả (đã gửi)</option>
                                <option value={trangThaiHoSoDuTuyenValue.choDuyet}>Chờ duyệt</option>
                                <option value={trangThaiHoSoDuTuyenValue.duyet}>Đã duyệt</option>
                                <option value={trangThaiHoSoDuTuyenValue.tuChoi}>Từ chối</option>
                                <option value={trangThaiHoSoDuTuyenValue.canChinhSua}>Cần chỉnh sửa</option>
                            </Form.Control>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <span className="font-weight-bold mr-2">Năm:</span>
                            <Form.Control as="select" value={namTuyenSinh} onChange={(e) => { setNamTuyenSinh(Number(e.target.value)); setPage(1); }} style={{ width: '120px' }}>
                                {listNam.map((year) => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Control>
                        </div>
                    </div>
                    <div className="table-responsive flex-grow-1" ref={tableRef}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th style={activeTab === '0' ? { width: '50px' } : {}}>STT</th>
                                    <th style={{ width: '110px' }}>Số hồ sơ</th>
                                    <th style={activeTab === '0' ? { width: '120px' } : {}}>Số CCCD</th>
                                    <th style={activeTab === '0' ? { width: '200px' } : {}}>Người nộp</th>
                                    <th>{activeTab === '0' ? 'Đợt tuyển sinh' : 'Lớp tuyển sinh'}</th>
                                    <th style={activeTab === '0' ? { width: '160px' } : {}}>Ngày nộp</th>
                                    <th className="text-center" style={activeTab === '0' ? { width: '130px' } : {}}>Trạng thái</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={7}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={7}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={7}>Không có hồ sơ nào.</td>
                                    </tr>
                                ) : (
                                    items.map((app, idx) => {
                                        const statusValue = app.trangThaiHoSoDuTuyen;
                                        const statusLabel = getLabelFromEnum(statusValue, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue);
                                        const isChoDuyet = statusLabel === 'Chờ duyệt' || Number(statusValue) === 1;
                                        let cDate = app.ngayNop || app.createdDate;
                                        const dateStr = cDate ? moment(cDate).format('DD/MM/YYYY HH:mm') : '';
                                        return (
                                            <tr 
                                                key={app.id}
                                                onClick={() => setSelectedRow(app)}
                                                className={selectedRow && selectedRow.id === app.id ? 'table-primary' : ''}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <td>{(page - 1) * pageSize + idx + 1}</td>
                                                <td>{app.soHoSo || 'Chưa cấp'}</td>
                                                <td>{app.soCCCD}</td>
                                                <td>{app.hoTen}</td>
                                                <td>{app.tenDotTuyenSinh}</td>
                                                <td>{dateStr}</td>
                                                <td className="text-center">
                                                    <BsBadge 
                                                        variant={
                                                            statusLabel === 'Duyệt' ? 'success' :
                                                            statusLabel === 'Từ chối' ? 'danger' :
                                                            statusLabel === 'Cần chỉnh sửa' ? 'warning' : 'info'
                                                        } 
                                                        className="px-2 py-1"
                                                    >
                                                        {statusLabel}
                                                    </BsBadge>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>
                            </Tab.Pane>
                        </Tab.Content>
                </Card.Body>
                {!isLoading && (
                    <Card.Footer className="bg-white card-footer-sticky">
                        <div className="d-flex justify-content-end pr-4">
                            <Button
                                variant="info"
                                size="sm"
                                className="mr-2"
                                disabled={!selectedRow}
                                onClick={() => handleViewDetail(selectedRow)}>
                                <i className="fas fa-eye mr-1"></i> Kiểm tra hồ sơ
                            </Button>
                            <Button
                                variant="success"
                                size="sm"
                                className="mr-2"
                                disabled={!selectedRow || getLabelFromEnum(selectedRow?.trangThaiHoSoDuTuyen ?? selectedRow?.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue) === 'Duyệt'}
                                onClick={() => handleOpenConfirm(selectedRow, 3)}>
                                <i className="fas fa-check mr-1"></i> Duyệt
                            </Button>
                            <Button
                                variant="warning"
                                size="sm"
                                className="mr-2 text-white"
                                disabled={!selectedRow || getLabelFromEnum(selectedRow?.trangThaiHoSoDuTuyen ?? selectedRow?.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue) === 'Cần chỉnh sửa'}
                                onClick={() => handleOpenConfirm(selectedRow, 2)}>
                                <i className="fas fa-edit mr-1"></i> Yêu cầu chỉnh sửa
                            </Button>
                            <Button
                                variant="danger"
                                size="sm"
                                className="mr-2"
                                disabled={!selectedRow || getLabelFromEnum(selectedRow?.trangThaiHoSoDuTuyen ?? selectedRow?.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue) === 'Từ chối'}
                                onClick={() => handleOpenConfirm(selectedRow, 4)}>
                                <i className="fas fa-times mr-1"></i> Từ chối
                            </Button>
                            {activeTab === '0' && (
                                <>
                                    <Button
                                        variant="warning"
                                        size="sm"
                                        className="mr-2 text-white"
                                        disabled={!selectedRow}
                                        onClick={() => {
                                            setSelectedHoSoIdDanhGia(selectedRow.id || selectedRow.Id);
                                            setShowDanhGiaModal(true);
                                        }}>
                                        <i className="fas fa-check-square mr-1"></i> Đánh giá hồ sơ
                                    </Button>
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        className="mr-2"
                                        disabled={!selectedRow}
                                        onClick={() => handleOpenChamDiem(selectedRow)}>
                                        <i className="fas fa-star mr-1"></i> Chấm điểm
                                    </Button>
                                </>
                            )}
                            <Button
                                size="sm"
                                className="text-white"
                                style={{ backgroundColor: '#6f42c1', borderColor: '#6f42c1' }}
                                disabled={!selectedRow}
                                onClick={() => {
                                    setSelectedHoSoIdKetQua(selectedRow.id || selectedRow.Id);
                                    setShowKetQuaModal(true);
                                }}>
                                <i className="fas fa-award mr-1"></i> Kết quả tuyển sinh
                            </Button>
                        </div>
                    </Card.Footer>
                )}
                    </Card>
                </Card.Body>
            </Card>
            </Tab.Container>

            {showDetail && (
                <DuyetHoSoTuyenSinhDetailModal 
                    show={showDetail} 
                    handleClose={() => {
                        setShowDetail(false);
                        setSelectedHoSoId(null);
                        queryClient.invalidateQueries(['duyetHoSoTuyenSinh']);
                        refetch();
                    }} 
                    hoSoId={selectedHoSoId} 
                />
            )}

            {showChamDiemModal && (
                <ChamDiemDeCuongModalWrapper
                    show={showChamDiemModal}
                    handleClose={() => {
                        setShowChamDiemModal(false);
                        setSelectedHoSoIdChamDiem(null);
                        queryClient.invalidateQueries(['duyetHoSoTuyenSinh']);
                        refetch();
                    }}
                    hoSoId={selectedHoSoIdChamDiem}
                />
            )}

            {showDanhGiaModal && (
                <Modal show={showDanhGiaModal} onHide={() => { setShowDanhGiaModal(false); setSelectedHoSoIdDanhGia(null); queryClient.invalidateQueries(['duyetHoSoTuyenSinh']); refetch(); }} size="xl" backdrop="static" style={{ zIndex: 10000 }}>
                    <Modal.Header closeButton className="bg-primary text-white">
                        <Modal.Title><i className="fas fa-check-square mr-2"></i> Đánh giá hồ sơ</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                        <DanhGiaHoSoTuyenSinhTienSiForm hoSoId={selectedHoSoIdDanhGia} readOnly={false} handleClose={() => setShowDanhGiaModal(false)} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => { setShowDanhGiaModal(false); setSelectedHoSoIdDanhGia(null); queryClient.invalidateQueries(['duyetHoSoTuyenSinh']); refetch(); }}>Đóng</Button>
                    </Modal.Footer>
                </Modal>
            )}

            {showKetQuaModal && (
                <Modal show={showKetQuaModal} onHide={() => { setShowKetQuaModal(false); setSelectedHoSoIdKetQua(null); queryClient.invalidateQueries(['duyetHoSoTuyenSinh']); refetch(); }} size="xl" backdrop="static" style={{ zIndex: 10000 }}>
                    <Modal.Header closeButton className="bg-primary text-white">
                        <Modal.Title><i className="fas fa-award mr-2"></i> Kết quả tuyển sinh</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                        <KetQuaTuyenSinhTab hoSoId={selectedHoSoIdKetQua} loaiTuyenSinh={Number(activeTab)} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => { setShowKetQuaModal(false); setSelectedHoSoIdKetQua(null); queryClient.invalidateQueries(['duyetHoSoTuyenSinh']); refetch(); }}>Đóng</Button>
                    </Modal.Footer>
                </Modal>
            )}

            {/* Confirm Modal for Từ chối / Cần chỉnh sửa */}
            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} backdrop="static" style={{ zIndex: 10000 }} centered>
                <Modal.Header closeButton className={actionType === 4 ? 'bg-danger text-white' : actionType === 3 ? 'bg-success text-white' : 'bg-warning text-white'}>
                    <Modal.Title>{actionType === 4 ? 'Từ chối hồ sơ' : actionType === 3 ? 'Duyệt hồ sơ' : 'Yêu cầu chỉnh sửa hồ sơ'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {actionType === 3 && (
                        <p className="mb-3 text-success font-weight-bold">Bạn có chắc chắn muốn DUYỆT hồ sơ này?</p>
                    )}
                    <Form.Group>
                        <Form.Label className="font-weight-bold">
                            Ghi chú / Lý do {(actionType === 2 || actionType === 4) && <span className="text-danger">*</span>}
                        </Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={4} 
                            placeholder={actionType === 3 ? "Nhập ghi chú (không bắt buộc)..." : "Nhập ghi chú hoặc lý do cho ứng viên..."}
                            value={ghiChuChinhSua} 
                            onChange={(e) => setGhiChuChinhSua(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Hủy</Button>
                    <Button 
                        variant={actionType === 4 ? 'danger' : actionType === 3 ? 'success' : 'warning'} 
                        className={(actionType === 2 || actionType === 3) ? 'text-white' : ''}
                        disabled={submitting} 
                        onClick={() => handleDuyet()}
                    >
                        {submitting ? 'Đang xử lý...' : 'Xác nhận'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DuyetHoSoTuyenSinh;
